import { useState, useEffect } from "react";

export function usePagination ( fetchData, campoRegistrosDaListagem, buscarDadosAutomaticamente = true, tamanhoPagina ) {
    const [dados, setDados] = useState([]);
    const [paginacaoLoading, setPaginacaoLoading] = useState(true);
    const [paginasArmazenadas, setPaginasArmazenadas] = useState({});
    const [filtroAplicado, setFiltroAplicado] = useState('');
    const [filtroPorColuna, setFiltroPorColuna] = useState({});
    const [paginacaoErro, setPaginacaoErro] = useState({temErro: false, mensagens: [], statuscode: 0});
    const [isMounted, setIsMounted] = useState(true);
    const [paginacaoOpcoes, setPaginacaoOpcoes] = useState({
        total: 0,
        tamanhoPagina: 10,
        paginaAtual: 1,
        skipToken: '',
        filtro: ''
    });
    const [ordenacaoCampo, setOrdenacaoCampo] = useState('');
    const [ordenacaoDirecao, setOrdenacaoDirecao] = useState('');

    useEffect(()=>{
        if (tamanhoPagina) {
            setPaginacaoOpcoes(prev => ({ ...prev, tamanhoPagina: tamanhoPagina }));
        }

        if (buscarDadosAutomaticamente) {
            executarFetchData();
        }

        return () => {
            setIsMounted(false);
        }
    }, []);

    const executarFetchData = async (
        paginaAtual = 1, 
        tamanhoPagina = paginacaoOpcoes.tamanhoPagina, 
        filtro = '', 
        skipToken = '',
        filtroPorColunaTable = filtroPorColuna,
        campoOrdenacao = ordenacaoCampo,
        ordenacao = ordenacaoDirecao
    ) => {
        try {
            setPaginacaoLoading(true);
            const response = await fetchData(tamanhoPagina, 
                                             filtro, 
                                             skipToken, 
                                             paginaAtual, 
                                             filtroPorColunaTable,
                                             campoOrdenacao,
                                             ordenacao);
            if(!response || !isMounted) return;

            setPaginacaoOpcoes((paginacaoOpcoes) => ({
                ...paginacaoOpcoes,
                total: paginaAtual == 1 ? response.quantidadeRegistros : paginacaoOpcoes.total,
                skipToken: response.skipToken == null ? '' : response.skipToken
            }));

            setDados(response[campoRegistrosDaListagem]);
            setPaginasArmazenadas((prevPaginasArmazenadas) => ({
                ...prevPaginasArmazenadas,
                [paginaAtual]: response[campoRegistrosDaListagem] 
            }));
        }
        catch (error) {
            setPaginacaoErro({temErro: true, statuscode: error.response?.status, mensagens: error.response?.data?.erros ?? ['Erro inesperado ao obter os registros.']});
        }
        finally {
            setPaginacaoLoading(false);
        }
    }

    const handleAlteracaoDePaginacao = async (paginaAtual = paginacaoOpcoes.paginaAtual, tamanhoPagina = paginacaoOpcoes.tamanhoPagina) =>{
        let tamanhoPaginaAtual = paginacaoOpcoes.tamanhoPagina;
        let skipToken = paginacaoOpcoes.skipToken;
    
        if (tamanhoPaginaAtual != tamanhoPagina) {
            skipToken = '';
            paginaAtual = 1;
            setPaginasArmazenadas({});
        }
    
        setPaginacaoOpcoes({
            ...paginacaoOpcoes,
            paginaAtual,
            tamanhoPagina,
            skipToken
        })

        if(paginasArmazenadas[paginaAtual] && tamanhoPaginaAtual == tamanhoPagina){
            setDados(paginasArmazenadas[paginaAtual]);
        } else {
            await executarFetchData(paginaAtual, tamanhoPagina, '', skipToken, filtroPorColuna);
        }
    }

    const handleFiltro = async (valorFiltro) => {
        setPaginasArmazenadas({});
        setFiltroAplicado(valorFiltro);
        setPaginacaoOpcoes({
            ...paginacaoOpcoes,
            paginaAtual: 1
        });
    
        await executarFetchData(1, paginacaoOpcoes.tamanhoPagina, valorFiltro, '', filtroPorColuna);
    }

    const handleTableChange = async (paginationAntd, filters, sorter, extra) => {
        const newFiltroPorColuna = {};
        for (const key in filters) {
            if (filters[key] && filters[key].length > 0) {
                newFiltroPorColuna[key] = filters[key][0];
            } else {
                newFiltroPorColuna[key] = null;
            }
        }

         const campoOrdenacao = Array.isArray(sorter)
        ? sorter[0]?.columnKey
        : sorter?.columnKey;

        const direcaoOrdenacao = Array.isArray(sorter)
            ? sorter[0]?.order
            : sorter?.order;

        const ordenacao = direcaoOrdenacao === 'ascend' ? true : direcaoOrdenacao === 'descend' ? false : '';

        setFiltroPorColuna(newFiltroPorColuna);
        setPaginasArmazenadas({});
        setPaginacaoOpcoes(prev => ({
            ...prev,
            paginaAtual: 1
        }));
        setOrdenacaoCampo(campoOrdenacao);
        setOrdenacaoDirecao(ordenacao);

        await executarFetchData(1, paginacaoOpcoes.tamanhoPagina, paginacaoOpcoes.filtro, '', newFiltroPorColuna, campoOrdenacao, ordenacao);
        
    };

    const resetarPaginacao = () => {
        setPaginasArmazenadas({});
        setFiltroAplicado('');
        setFiltroPorColuna({});
        setPaginacaoOpcoes({
            ...paginacaoOpcoes,
            total: 0,
            paginaAtual: 1,
            skipToken: '',
            filtro: ''
        });   
    }

    const atualizarDadosDaPagina = (pagina, dados) => 
    {
        if (pagina == paginacaoOpcoes.paginaAtual ) {
            setDados(dados);
        } 

        setPaginasArmazenadas((prevPaginasArmazenadas) => ({
            ...prevPaginasArmazenadas,
            [pagina]: dados
        }));
    }

    return {
        dados,
        paginacaoOpcoes,
        paginacaoLoading,
        paginacaoErro,
        filtroAplicado,
        filtroPorColuna,
        paginasArmazenadas,
        handleAlteracaoDePaginacao,
        executarFetchData,
        setDados,
        setPaginasArmazenadas,
        handleFiltro,
        setPaginacaoLoading,
        resetarPaginacao,
        handleTableChange,
        atualizarDadosDaPagina
    };
};